export async function toArray<TSource>(source: AsyncIterable<TSource>): Promise<TSource[]> {
  let results = [] as TSource[];
  for await (let item of source) {
    results.push(item);
  }
  return results;
}



// WEBPACK FOOTER //
// ./node_modules/ix/asynciterable/toarray.ts